<template>
  <div>
    <el-button
      type="primary"
      style="margin-bottom:10px;margin-left:500px;"
      @click="showlist()"
      v-if="data.status==2||data.status==6"
    >打印配货单</el-button>
    <hr class="zhongX" />
    <div class="title">订单详情</div>
    <el-form ref="data" size="mini" :model="data" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="订单编号:" prop="id">{{data.id}}</el-form-item>
          <el-form-item label="订单金额：" prop="shouldPayAmt">{{(data.shouldPayAmt/100).toFixed(2)}}元</el-form-item>
          <el-form-item
            label="下单时间:"
            prop="name"
          >{{data.rowCrtTs | formatDate("yyyy-MM-dd hh:mm:ss")}}</el-form-item>
          <el-form-item
            label="配送时间:"
            prop="name"
          >{{data.expressTime | formatDate("yyyy-MM-dd hh:mm:ss")}}</el-form-item>
          <el-form-item
            label="配送费:"
            prop="expressFee"
          >{{(data.expressAmt.expressFee/100).toFixed(2)}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单状态:" prop="status">{{options[data.status]}}</el-form-item>
          <el-form-item label="实付金额：" prop="actualPayAmt">{{(data.actualPayAmt/100).toFixed(2)}}元</el-form-item>
          <el-form-item
            label="支付时间"
            prop="name"
          >{{data.payTime | formatDate("yyyy-MM-dd hh:mm:ss")}}</el-form-item>
          <el-form-item label="支付方式：" prop="payType">{{payTypeArr[data.payType]}}</el-form-item>
          <el-form-item label="包装费:" prop="name">{{(data.expressAmt.packingBoxFee/100).toFixed(2)}}</el-form-item>
        </el-col>
      </el-row>
      <hr class="zhongX" />
      <div class="title">商品信息</div> 
      <el-table header-cell-class-name="cen" cell-class-name="cen" :data="data.goodsList">
        <!-- <el-table-column label="序号" type="index" width="55px"></el-table-column> -->
        <el-table-column property="gdName" label="商品名称"></el-table-column>
        <el-table-column property="gdNum" label="数量">
          <template slot-scope="scope">{{(scope.row.gdNum/100)}}</template>
        </el-table-column>
        <el-table-column property="gdAmt" label="单价">
          <template slot-scope="scope">{{(scope.row.gdAmt/100).toFixed(2)}}元</template>
        </el-table-column>
        <el-table-column property="gdTotalAmt" label="总计">
          <template slot-scope="scope">{{(scope.row.gdTotalAmt/100).toFixed(2)}}元</template>
        </el-table-column>
      </el-table>
      <hr class="zhongX" style="margin-top:10px;" />
      <div class="title">收货人信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收货人:" prop="consigneeName">{{data.historyAddress.consigneeName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货人电话:" prop="consigneePhone">{{data.historyAddress.consigneePhone}}</el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="收货人地址:"
            prop="consigneeAddress"
          >{{data.historyAddress.consigneeAddress}}</el-form-item>
        </el-col>
      </el-row>
      <hr class="zhongX" />
      <div class="title">配送信息</div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="赠送商品:" prop="freebiesName">{{data.freebiesName}}</el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="配货备注:" prop="expressRemark">{{data.expressRemark}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align:center">
      <el-button size="mini" @click="close">取 消</el-button>
    </div>
    <el-dialog
      title="打印配货单"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      :append-to-body="true"
    >
      <el-form
        ref="formInline"
        size="mini"
        :model="formInline"
        class="demo-ruleForm"
        label-width="100px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="是否有赠送" prop="freebiesStatus">
              <el-select clearable v-model="formInline.freebiesStatus" placeholder="请选择">
                <el-option v-for="(v,k) in optionstrue" :key="k" :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="赠送商品" v-if="formInline.freebiesStatus==1" prop="freebiesName">
              <el-input v-model="formInline.freebiesName" style="width:190px"></el-input>
            </el-form-item>
            <el-form-item label="配货备注" prop="expressRemark">
              <el-input v-model="formInline.expressRemark" style="width:190px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submited" size="mini">确定</el-button>
        <el-button @click="centerDialogVisible = false" size="mini">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: { id: String },
  created() {
    this.load();
  },
  data() {
    return {
      data: {
        expressAmt: {
          expressFee: ""
        },
        historyAddress: {
          consigneeName: "",
          consigneePhone: ""
        }
      },
      rules: {
        freebiesStatus: [
          { required: true, message: "请选择是否有赠送", trigger: "blur" }
        ],
        freebiesName: [
          { required: true, message: "请输入赠送商品名称", trigger: "blur" },
          { min: 1, max: 10, message: "长度不能大于10个字符", trigger: "blur" }
        ],
        expressRemark: [
          { min: 1, max: 50, message: "最多为50个字", trigger: "blur" }
        ]
      },
      formInline: {
        freebiesStatus: "",
        freebiesName: "",
        expressRemark: ""
      },
      centerDialogVisible: false,
      payTypeArr: {
        0: "微信",
        1: "支付宝"
      },
      options: {
        0: "待支付",
        2: "支付成功",
        3: "支付失败",
        4: "已关闭",
        6: "已配送"
      },
      optionstrue: {
        0: "否",
        1: "是"
      }
    };
  },
  methods: {
    load() {
      this.$http.post(`/w/order/detail/single/${this.id}`, {}).then(data => {
        this.data = data.data;
      });
    },
    close() {
      this.$emit("close");
    },
    showlist() {
      if (this.data.printStatus == 1) {
        this.$confirm("此操作将打印配货单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$http
              .post(`/w/order/freebies`, { id: this.data.id })
              .then(data => {
                // this.$message({
                //   type: "success",
                //   message: "打印成功!"
                // });
                let resinner = "";
                for (let i in data.data) {
                  resinner += data.data[i] + "</br>";
                }
                this.$message({
                  type: "success",
                  dangerouslyUseHTMLString: true,
                  message: `<p>${resinner}</p>`
                });
                this.load();
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      } else {
        this.centerDialogVisible = true;
      }
    },
    submited() {
      this.$refs["formInline"].validate(v => {
        if (v) {
          this.fullscreenLoading = true;
          this.$http
            .post(`/w/order/freebies`, { ...this.formInline, id: this.data.id })
            .then(data => {
              this.fullscreenLoading = false;
              this.$message({
                type: "success",
                message: "打印成功"
              });
              this.load();
              this.centerDialogVisible = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/page/orderAdmin/detaile.vue